import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import "./index.scss";

export default function Settings() {
  const location = useLocation();
  const navigate = useNavigate();
  const [imagePath, setImagePath] = useState("./");

  useEffect(() => {
    if (
      location.pathname === "/settings/company-info" ||
      location.pathname === "/settings/security" ||
      // location.pathname === "/settings/providers" ||
      location.pathname === "/settings/locations" ||
      location.pathname === "/settings/payment-method" ||
      location.pathname === "/settings/faq"
    ) {
      setImagePath("../../");
    } else {
      setImagePath("./");
    }
    if (location.pathname === "/settings") {
      navigate("/settings/company-info");
    }
  }, [location]);

  return (
    <>
      <Header title={"Settings"} />
      <div className="settings__inner">
        <div className="settings__tabs">
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/company-info"
                ? "settings__tab_active"
                : ""
            }`}
            to="company-info"
          >
            <span>
              <img
                src={`${"/assets/icons/personal.svg"}`}
                alt="company info"
              />
            </span>
            <p>Company info</p>
          </NavLink>
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/security"
                ? "settings__tab_active"
                : ""
            }`}
            to="security"
          >
            <span>
              <img src={`${"/assets/icons/security.svg"}`} alt="security" />
            </span>
            <p>Security</p>
          </NavLink>
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/locations"
                ? "settings__tab_active"
                : ""
            }`}
            to="locations"
          >
            <span>
              <img src={`${"/assets/icons/locations.svg"}`} alt="locations" />
            </span>
            <p>Locations</p>
          </NavLink>
            <NavLink
                className={`settings__tab ${
                    location.pathname === "/settings/credits"
                        ? "settings__tab_active"
                        : ""
                }`}
                to="credits"
            >
            <span>
              <img
                  src={`${"/assets/icons/credits.svg"}`}
                  alt="credits"
              />
            </span>
                <p>Tokens</p>
            </NavLink>
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/payment-method"
                ? "settings__tab_active"
                : ""
            }`}
            to="payment-method"
          >
            <span>
              <img
                src={`${"/assets/icons/payment.svg"}`}
                alt="payment method"
              />
            </span>
            <p>Payment Method</p>
          </NavLink>
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/faq"
                ? "settings__tab_active"
                : ""
            }`}
            to="faq"
          >
            <span>
              <img src={`${"/assets/icons/faq.svg"}`} alt="FAQ" />
            </span>
            <p>FAQ</p>
          </NavLink>
          <NavLink
            className={`settings__tab ${
              location.pathname === "/settings/terms"
                ? "settings__tab_active"
                : ""
            }`}
            to="terms"
          >
            <span>
              <img src={`${"/assets/icons/terms.svg"}`} alt="FAQ" />
            </span>
            <p>Terms & Conditions</p>
          </NavLink>
          <NavLink
              className={`settings__tab ${
                  location.pathname === "/settings/privacy-policy"
                      ? "settings__tab_active"
                      : ""
              }`}
              to="privacy-policy"
          >
            <span>
              <img src={`${"/assets/icons/privacy.svg"}`} alt="FAQ" />
            </span>
            <p>Privacy policy</p>
          </NavLink>
        </div>
        <Outlet />
      </div>
    </>
  );
}
